import { compose } from "async";
import React from "react";
import { CourseDetailLeft } from "./course-detail-left";
import { CourseDetailRight } from "./course-detail-right";
export const CourseDetailView = (props) => {
	return (
		<div className="course-detail-main">
			<div className="course-detail-frame-wrapper">
				<div className="course-detail-left">
					<CourseDetailLeft {...props} />
				</div>
				{/* course-details-left end */}
				<div className="course-detail-right">
					<CourseDetailRight {...props} />
				</div>
				{/* course-details-right end */}
			</div>
			{/* course-detail-frame-wrapper end */}
		</div>
		// course-details-main end
	);
};
